module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ernest C. Lucas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Ernest C. Lucas")]), _vm._v(" is vice principal emeritus of Bristol Baptist College and an honorary research fellow in theology and religious studies at the University of Bristol. His other books include commentaries on Daniel and Ezekiel and a textbook on the Psalms and wisdom literature. A former research biochemist, he has also written books and articles on science and Christian faith."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ujDldb/tc-custom/9781467443999.jpg?1730488364086",
      "alt": "This image is the cover for the book Proverbs, The Two Horizons Old Testament Commentary (THOTC)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Proverbs, The Two Horizons Old Testament Commentary (THOTC)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this erudite yet accessible commentary Ernest Lucas elucidates the book of Proverbs both exegetically and thematically. Explicating the text in light of its ancient Near Eastern context, Lucas also shows the relevance of Proverbs for the twenty-first century, speaking as it does to such issues as character formation, gender relations, wealth and poverty, interpersonal communication, science and religion, and care for the environment."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Lucas uniquely identifies “proverbial clusters” in his critical exegesis of the biblical text and uses them as the basis for interpreting individual proverbs. Several substantial theological essays at the end of the book illuminate major ethical, pastoral, and spiritual themes in Proverbs. Ably unpacking the rich wisdom embedded in the book of Proverbs, Lucas’s accessible theological commentary is perfect for pastors, teachers, and students."), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0